exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group_buy_config[data-v-25159e32]{\n  padding: 20px;\n}\n", ""]);

// exports
